/*
 * ******************************************************************
 * Copyright (c) 2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColumnSpec, ExportSpec, ExportType } from "@shared/models/csv-export.model";

@Component({
  selector: 'dg-export',
  standalone: false,
  templateUrl: './dg-export.component.html',
  styleUrl: './dg-export.component.scss'
})
export class DgExportComponent {
    @Input()
    ariaLabel: string = "export.datagrid.aria.label.items";

    @Input()
    allRowsCount: number = 0;

    @Input()
    filteredRowsCount: number = 0;

    @Input()
    hasSelection: boolean = false;

    @Input()
    selectedRowsCount: number = 0;

    @Input()
    serverDriven: boolean = false;

    @Input()
    columnSpecs: ColumnSpec[] = [];

    @Input()
    includeAllColumns: boolean = false;

    @Input()
    exportInProgress: boolean = false;

    @Output()
    exportData: EventEmitter<ExportSpec> = new EventEmitter<ExportSpec>();

    export(type: ExportType): void {
        this.exportData.emit(
            {
                type: type,
                columnSpecs: this.columnSpecs,
                includeAllColumns: this.includeAllColumns
            });
    }
}
